import { Component, OnInit, Inject } from '@angular/core';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormBuilder } from '@angular/forms';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { LoaderService } from '../../shared/loader/loader.service';

@Component({
  selector: 'app-addOffice',
  templateUrl: './addOffice.component.html',
  styleUrls: ['./addOffice.component.scss'] 
})

export class AddOfficeComponent implements OnInit {
  
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  
  OfficeIDList: any=[];
  myOfficeID: any;
  
  spinner:boolean=false;
  officeList:any=[]=[];
  ShowNoRecordFoundOffice:boolean=false;
  selectedOrganizationId:number=0;

  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    organizationID:0,
    officeID:0
  };
  pageIndex: any;
  pageSize: any;
  organizationResponseHolder: any;
  organizationList: any;

  constructor(private dialog: MatDialog,public dialogRef: MatDialogRef<AddOfficeComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private settingsService: SettingService,
    private statusConst: StatusConstant,private toastr: ToastrService,
    private loaderService: LoaderService,) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);   
    this.currentUser = jwt_decode(token); 
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }  
  
  ngOnInit(): void {  
    this.getOraganizationList(this.pageModelData);
  }
  
  getOraganizationList(pageData: any) {
    this.loaderService.show();    
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.organizationID = Number(this.organizationId);
    this.pageModelData.officeID = 0;//this.myOfficeID;
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    this.settingsService.getOffices(this.pageModelData).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.officeList=[];
        this.organizationResponseHolder = response;
        if (this.organizationResponseHolder.status == this.statusConst.statusSuccess) {
           this.organizationList=this.organizationResponseHolder.data.organizations;
           if(this.organizationResponseHolder.data.organizations[0].offices.length>0){
            this.officeList=this.organizationResponseHolder.data.organizations[0].offices;
          }
          var obj={
            officeName:this.organizationList[0].officeName,
            officeID:this.organizationList[0].officeID,
            organizationID:this.organizationList[0].organizationID,
            email: this.organizationList[0].email,
          }
          this.officeList.push(obj);
          if (this.officeList.length > 0) {
            this.officeList=this.officeList.filter(x=>x.officeID!=this.myOfficeID);
            if(this.officeList.length>0){
              this.ShowNoRecordFoundOffice = false;
            }
            else {
              this.ShowNoRecordFoundOffice = true;
            } 
          } else {
            this.ShowNoRecordFoundOffice = true;
          }                 
        }else{
          this.organizationList = [];
          this.officeList=[];
          this.loaderService.hide();
        }
      }else{
        this.organizationList =[];
        this.officeList=[];
        this.loaderService.hide(); 
      }
    });
  }

  SelectOffice(data){
    this.selectedOrganizationId = data.officeID;
  }

  onFolderSelectToMove(){
    var cType;
    var ciDs=[];
    if(this.data.moduleName=="Core"){
      cType =1;
    }
    if(this.data.moduleName=="Contact"){
      cType =2;
    }
    if(this.data.moduleName=="Company"){
      cType =3;
    }
    
    if (this.data.selectedRecord.length > 0) { 
      for (let i = 0; i < this.data.selectedRecord.length; i++) {
       var obj={
        id: this.data.selectedRecord[i].selectedRecord
       }
       ciDs.push(obj);
      }
    }   
    let ReqModel = {
      moveToOffcieID:Number(this.selectedOrganizationId),
      cType:Number(cType),
      ciDs:ciDs,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      officeID:Number(this.myOfficeID),
      databaseID:Number(this.databaseId)
    }
    //return;
    this.spinner=true;  
    this.loaderService.show(); 
    this.settingsService.move3CtoAnotherOffice(ReqModel).subscribe((response)=>{
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner=false;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.dialogRef.close('Added');
          this.toastr.success('Record moved successfully.', '', {
            timeOut: 2000,
          });     
        }else{
          this.loaderService.hide();
          this.spinner=false;
          this.toastr.warning('Record moved failed.', '', {
            timeOut: 2000,
          });         
        }
      }else{
        this.loaderService.hide();
        this.spinner=false;
        this.toastr.warning('Record moved failed.', '', {
          timeOut: 2000,
        }); 
      }
    })
  }

 

  close() {    
     this.dialog.closeAll();
  } 
  
}


